"use client";

export const CopyrightYear = () => <>{new Date().getFullYear()}</>;
